import { createFeatureSelector, createSelector } from '@ngrx/store';

import { Template } from '../../interfaces/template.interface';
import { selectAllTemplate, TemplateState } from '../reducers/template.reducer';

export const selectTemplateState = createFeatureSelector<TemplateState>('templates');

export const selectAllTemplates = createSelector(selectTemplateState, selectAllTemplate);

export const selectTemplateById = (id: string) =>
  createSelector(selectTemplateState, (state) => state.entities[id]);

export const selectSearchedTemplates = createSelector(
  selectTemplateState,
  ({ search, entities }) => {
    const results: Template[] = [];

    search.results.forEach((id) => {
      if (entities[id]) {
        results.push(entities[id]);
      }
    });

    return results;
  },
);

export const selectSearchedParams = createSelector(
  selectTemplateState,
  ({ search }) => search.params,
);

export const selectTemplateStatePending = createSelector(
  selectTemplateState,
  ({ pending }) => pending,
);

export const selectTemplateStateError = createSelector(
  selectTemplateState,
  (state) => state.error
);
